import { useState } from 'outpost/preact';
import { Button } from '../base-components/button.tsx';
import { GAME_ID_PARAM_NAME } from '../constants.ts';
import { BoardLocalData } from './board-local-data.ts';
import { ClientConnection } from './client-connection.ts';

export type BoardLinkComponentProps = {
    localData: BoardLocalData;
    isGuest: boolean;
};

export function BoardLinkComponent(props: BoardLinkComponentProps) {
    let { localData, isGuest } = props;
    let [roomId, setRoomId] = useState<string | null>(null);
    let [isConnected, setIsConnected] = useState(!!localData.connection);
    let [hostConnection, setHostConnection] = useState<ClientConnection | null>(null);

    let onCreateLink = async () => {
        hostConnection = await ClientConnection.start({ label: 'host' });

        setHostConnection(hostConnection);

        roomId = await hostConnection.createGame(localData);

        setRoomId(roomId);
        await onCopyGameLink();

        setIsConnected(true);
        localData.setConnection(hostConnection);
        // hostConnection.whenConnected().then(() => setIsConnected(true));
    };

    let onCopyGameLink = async () => {
        let url = new URL(location.origin);
        url.searchParams.set(GAME_ID_PARAM_NAME, roomId!);

        let gameLink = url.toString();

        await navigator.clipboard.writeText(gameLink);

        console.log(`Game link: ${gameLink}`);
    };

    if (roomId || isGuest) {
        return <Button
            label='Copy join link'
            onClick={onCopyGameLink}
        />;
    } else {
        return <Button
            label='Create join link'
            onClick={onCreateLink}
        />;
    }
};